<template>
  <div id="page" v-cloak>
    <div class="uoload_video">
      <p style="text-indent: 0.3rem;padding-left: 0;">通过来啊商城购物的用户，可以免费领取商品优惠券和购买折扣商品，在确认收货后可以提交您的订单编号信息和完整截图上传审核，审核通过后可以获得钻石奖励。</p>
      <h5>来啊商城入口：</h5>
      <p>
        <span style="color: #ff5555;"> 注：用户在来啊商城购物前，需确保手机已安装并登录淘宝app，以免出现优惠券领取不成功的情况。</span>
      </p>
      <h5>提交审核步骤：</h5>
      <p>
        <span style="font-weight: bold;">1、填写-复制你的订单编号填入输入框；</span></br>
        <img src="../img/upload_img1.png" />
        <span style="font-weight: bold;">2、上传-订单界面有显示“成交时间”的完整界面；</span></br>
        <img src="../img/upload_img2.png" />
        <span style="font-weight: bold;">3、提交审核；</span></br>
        <p style="padding-top: 0.1rema;">
          <span>订单编号：</span>
          <input class="tb_order_no" type="tel" @keyup="inputChange" style="width:6rem;border: 1px solid #999;height: 0.5rem;text-indent: 0.1rem;font-size: 0.34rem;"
            v-model="orderNumber" />
        </p>
        <p>
          <span>上传截图：</span>
          <span id="ossfile" class="ossfile">{{hintText}}</span>
        </p>
        <div id="uploader" class="wu-example">
          <!--用来存放文件信息-->
          <div id="fileList" class="uploader-list"></div>
          <div id="container" class="container">
            <p id="picker" class='btn'>选择文件</p>
            <p id="remove" class='btn' @click="stop">取消</p>
            <p id="postfiles" class='btn' @click="upload">提交审核</p>
            <p style="background: #4caf50;" class='btn' @click="openUploadRecord">上传记录</p>
          </div>
        </div>
      </p>
      <p style="color: #ff5555;font-weight: bold;">一经发现故意上传错误信息，违规信息，违规图片，一律封号处理；</p>
      <h5 style="color: #ff5555;">注：</h5>
      <p style="color: #ff5555;">
        1、每笔订单只能提交一次审核，务必请完成最终确认收货后再提交审核；</br>
        2、需要注意必须订单是确认收货状态才会显示成交时间；</br>
        3、每个用户每天只能上传一次；
      </p>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import WebUploader from 'webuploader'
  export default {
    name: 'Upload',
    data() {
      return {
        userId: '',
        H5Key: '',
        md5: '',
        uploader: null,
        isUpload: false,
        hintText: '请上传订单信息',
        visible: false,
        hint: '',
        orderNumber: '',
        token: '',
      }
    },
    mounted() {
      if(window.LaiaJs){
      	window.LaiaJs.setTitle('上传订单');
      	this.userId = window.LaiaJs.getUserId();
      	this.H5Key = window.LaiaJs.getH5Key();
      	this.md5 = this.$md5(this.H5Key);
      }else{
      	this.userId = '503a84e4f4374ec5916db6086bbe7b71';
      	this.H5Key = 'UpSzXt4t5tSwTD2uYqVC1vPxVA1DWAWq';
      	this.md5 = this.$md5(this.H5Key);
      }
      this.$axios({
        method: 'post',
        url: 'https://h5.wake888.com/index/Index/laiaTaobaoUpload',
        data:{
          "user_id": this.userId,
          "h5_key": this.md5,
        },
      }).then(res => {
        // console.log(res);
        if (res.data.message == 'ok') {
          this.formData = res.data.data;
          this.initWebUpload();
        }
      }).catch(function(error) {
        console.log(error);
      });
    },
    methods: {
      initWebUpload() {
        var _this = this;
        this.uploader = WebUploader.create({
          server: _this.formData.host,
          pick: "#picker",
          accept: {
            extensions: 'gif,jpg,jpeg,bmp,png',
            mimeTypes: 'image/*'
          },
          method: 'post',
          compress: false,
          prepareNextFile: true,
          chunked: true,
          chunkSize: 5242880,
          threads: 1,
          fileNumLimit: 1,
          fileSizeLimit: 1747626,
          fileSingleSizeLimit: 1747626,
        });
        // 当文件被加入队列以后触发。
        this.uploader.on('fileQueued', function(file) {
          var $list = $('#fileList');
          $list.append('<div id="' + file.id + '" ref="' + file.id + '" class="item">' +
            '<h4 class="info">' + file.name + '</h4>' +
            '<div class="state">等待提交审核...</div>' +
            '</div>');
        });
        // 上传过程中触发，携带上传进度。
        this.uploader.on('uploadProgress', function(file, percentage) {
          var $li = $('#' + file.id),
            $percent = $li.find('.progress .progress-bar');
          // 避免重复创建
          if (!$percent.length) {
            $percent = $('<div class="progress progress-striped active">' +
              '<div class="progress-bar" role="progressbar" style="width: 0%">' +
              '</div>' +
              '</div>').appendTo($li).find('.progress-bar');
          }
          $li.find('div.state').text('上传中');
          $percent.css('width', percentage * 100 + '%'); //根据上传进度改变进度条宽度
        });
        // 当文件被移除队列后触发。
        this.uploader.on('fileDequeued', function(file) {
          var id = file.id;
          $('#' + id).remove();
        });
        // 当文件上传成功时触发。
        this.uploader.on('uploadSuccess', function(file, response) {
          $('#' + file.id).find('div.state').text('上传成功');
          _this.Dialog('上传成功');
          // 上传成功上报
          _this.$axios.post("task/uploadTaobaoOrderImage.do", {
          	"user_id": _this.userId,
          	"sign": _this.md5,
            "tb_order_no": _this.orderNumber,
            "image1": _this.formData.filename,
          }).then((res) => {
          	console.log(res);
          	if(res.data.Error != ""){
          		if(window.LaiaJs){
          			window.LaiaJs.showMsg(res.data.Error);
          			return;
          		}else{
          			alert(res.data.Error);
          			return;
          		}
          	}
            return;
            _this.uploader.upload();
          }).catch((e) => {
          	//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          	console.log(e);
          })
        });
        // 当文件上传出错时触发。
        this.uploader.on('uploadError', function(file, reason) {
          $('#' + file.id).find('div.state').text('上传出错');
        });
        // 不管成功或者失败，文件上传完成时触发。
        this.uploader.on('uploadComplete', function(file) {
          $('#' + file.id).find('.progress').fadeOut();
        });
        // 当某个文件的分块在发送前触发
        this.uploader.on("uploadBeforeSend", function(block, data, headers) {
          data['key'] = _this.formData.dir + _this.formData.filename;
          data['policy'] = _this.formData.policy;
          data['OSSAccessKeyId'] = _this.formData.accessid;
          data['signature'] = _this.formData.signature;
        });
      },
      // 上传
      upload() {
        if (this.isUpload || this.uploader.getFiles('progress', 'complete').length > 0) {
          this.Dialog('今日已上传！');
          return;
        } else if (this.orderNumber == '') {
          this.Dialog('请输入订单编号！');
          return;
        } else if (this.uploader.getFiles('inited', 'queued').length <= 0) {
          this.Dialog('请选择上传图片！');
          return;
        }
        // 是否能上传
        this.$axios.post("task/checkUpload.do", {
        	"user_id": this.userId,
        	"sign": this.md5,
          "tb_order_no": this.orderNumber,
        }).then((res) => {
        	// console.log(res);
        	if(res.data.Error != ""){
        		if(window.LaiaJs){
        			window.LaiaJs.showMsg(res.data.Error);
        			return;
        		}else{
        			alert(res.data.Error);
        			return;
        		}
        	}
          this.uploader.upload();
        }).catch((e) => {
        	//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        	console.log(e);
        })
      },
      // 取消
      stop() {
        this.uploader.stop();
        let arr = this.uploader.getFiles('inited', 'queued', 'progress ', 'interrupt', 'error', 'invalid', 'cancelled');
        arr.forEach(item => {
          this.uploader.removeFile(item, true);
        })
      },
      // 上传记录
      openUploadRecord() {
        if (window.LaiaJs) {
          window.LaiaJs.openUrl('http://laia-common.yeedian365.com/laia_h5/index.html#/UploadList');
        }
      },
      inputChange() { //输入框值改变
        this.orderNumber = this.orderNumber.replace(/[^\d]/g, '')
      },
      // 弹窗
      Dialog(val) {
        if (window.LaiaJs) {
          window.LaiaJs.showMsg(val);
        } else {
          alert(val);
        }
      },
    },
  }
</script>

<style>
  [v-cloak] {
    display: none;
  }

  .uoload_video {
    padding: 0.2rem 0.3rem;
    font-size: 0.24rem;
  }

  .uoload_video h5 {
    font-size: 0.4rem;
    margin-bottom: 0.06rem;
  }

  .uoload_video p {
    padding-left: 0.15rem;
    font-size: 0.34rem;
    margin-bottom: 0.16rem;
    color: #333;
  }

  .uoload_video img {
    width: 100%;
    padding: 0.1rem 0;
  }

  .container p {
    padding: 0.16rem 0.48rem;
    display: inline-block;
    border-radius: 0.1rem;
    font-size: 0.4rem;
    background: #999;
    color: #fff;
    margin-right: 0.1rem;
    position: relative;
  }

  .uploader-list {
    padding: 0.3rem;
    padding-top: 0.1rem;
    font-size: 0.3rem;
    color: #999;
  }

  #postfiles {
    background: #10AEFF;
  }

  #remove {
    background: #ff5555;
    color: #fff;
  }

  .progress {
    margin-top: 0.1rem;
    width: 100%;
    height: 0.14rem;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
  }

  .progress-bar {
    background-color: rgb(92, 184, 92);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.14902) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.14902) 50%, rgba(255, 255, 255, 0.14902) 75%, transparent 75%, transparent);
    background-size: 0.4rem 0.4rem;
    box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: block;
    float: left;
    font-size: 0.12rem;
    height: 0.2rem;
    line-height: 0.2rem;
    text-align: center;
    transition-delay: 0s;
    transition-duration: 0.6s;
    transition-property: width;
    transition-timing-function: ease;
    width: 100%;
  }

  .webuploader-element-invisible {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Upload.vue